<template>
  <v-dialog v-model="dialog" max-width="1000" scrollable>
    <v-card>
      <v-card-title class="font-weight-bold">{{
        caixaSelec > 0 ? `Caixa ${caixaSelec}` : "Adicionar pedido"
      }}</v-card-title>
      <v-card-subtitle>
        <v-row dense>
          <v-col cols="12">
            {{
              caixaSelec > 0
                ? "Produtos disponíveis para esta caixa"
                : "Pedidos liberados para carregamento"
            }}
          </v-col>
          <v-col
            xl="4"
            lg="4"
            md="4"
            cols="12"
            align-self="center"
            v-if="caixaSelec > 0"
          >
            <v-select
              label="Produtos"
              :items="filtrosProdutos"
              item-text="text"
              v-model="filtroSelec"
              item-value="value"
              hide-details=""
            ></v-select>
          </v-col>
          <v-col
            :xl="caixaSelec == 0 ? 12 : 8"
            :lg="caixaSelec == 0 ? 12 : 8"
            :md="caixaSelec == 0 ? 12 : 8"
            cols="12"
            align-self="center"
          >
            <v-text-field
              label="Pesquisar"
              hide-details=""
              v-model="pesquisar"
              placeholder="Pesquisar por nome, cidade ou nº do pedido"
              :autofocus="!isMobile()"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-subtitle>
      <v-card-text>
        <v-progress-linear
          v-if="pedidosLiberados.carregando"
          indeterminate
        ></v-progress-linear>
        <v-alert type="error" text v-else-if="pedidosLiberados.msgErro != ''">{{
          pedidosLiberados.msgErro
        }}</v-alert>
        <v-data-table
          :hide-default-footer="pedidosLiberados.dados.length == 0"
          :hide-default-header="pedidosLiberados.dados.length == 0"
          v-else
          :items="pedidosFiltrados()"
          :headers="
            caixaSelec > 0 ? headersItensCx : headers.filter((h) => h.visible)
          "
          :search="pesquisar"
          :items-per-page="5"
          class="tabela-itens-fc"
          :no-data-text="
            caixaSelec > 0
              ? 'Nenhum item localizado'
              : 'Nenhum pedido encontrado'
          "
          no-results-text="Nenhum item localizado com esta pesquisa"
          :header-props="{ sortByText: 'Ordenar por' }"
          :show-expand="caixaSelec == 0"
          item-key="pesquisa"
          single-expand
        >
          <template v-slot:[`item.pesquisa`]="{ item }">
            <v-list-item
              dense
              :three-line="usuarioLogado.colaborador_interno && caixaSelec > 0"
            >
              <v-list-item-content>
                <!-- <v-list-item-subtitle
                  >Pedido {{ item.nr_pedido }}</v-list-item-subtitle
                > -->

                <v-list-item-title class="font-weight-bold mt-1">{{
                  item.nome_cliente
                }}</v-list-item-title>

                <v-list-item-subtitle>{{
                  item.cidade_entrega
                }}</v-list-item-subtitle>

                <v-list-item-subtitle
                  class="mt-1"                 
                >
                  <p class="caption mb-0">Vendedor: {{ item.desc_vendedor }}</p>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </template>
          <template v-slot:[`item.produto`]="{ item }">
            <span class="font-weight-bold"
              >{{ item.produto }} - {{ item.emb }}</span
            >
          </template>
          <template v-slot:[`item.cod`]="{ item }">
            {{ item.gp }}-{{ item.sgp }}-{{ item.item }}
          </template>
          <template v-slot:[`item.capac_cx`]="{ item }">
            <span v-if="item.capac_cx > 0">{{ item.capac_cx }}</span>
            <v-tooltip bottom v-else>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"                  
                  color="red"
                  size="22"
                  >mdi-alert-octagon-outline</v-icon
                >
              </template>
              <span>Caixa não possui capacidade para este produto</span>
            </v-tooltip>
          </template>
          <template v-slot:[`item.caixas`]="{ item }">
            <v-chip
              v-for="(cx, i) in cargaSelec.dist_caixas.filter(
                (dc) =>
                  dc.caixa > 0 &&
                  dc.pedido.filial == item.filial &&
                  dc.pedido.filial_destino == item.filial_destino &&
                  dc.pedido.nr_pedido == item.nr_pedido &&
                  dc.pedido.pessoa == item.pessoa &&
                  dc.pedido.gp == item.gp &&
                  dc.pedido.sgp == item.sgp &&
                  dc.pedido.item == item.item
              )"
              :key="i"
              color="white"
              dark
              text-color="secondary"
              class="mb-1 caption font-weight-bold"
              small
            >
              Caixa {{ cx.caixa }} - {{ cx.qtde }} Kgs</v-chip
            >
          </template>

          <template v-slot:[`item.saldo`]="{ item }">
            <span
              class="font-weight-bold subtitle-2"
              :class="{
                'green--text text--darken-2': item.saldo > 0,
                'red--text': item.saldo <= 0,
              }"
              >{{ item.saldo }}</span
            >
          </template>

          <template v-slot:[`item.itens`]="{ item }">
            <itens-pedido-form-carga :pedido="item" />
          </template>

          <template v-slot:[`item.selecionar`]="{ item }">
            <btn-selecionar-pedido-form-carga
              :disabled="excedeuPesoMax(item) || item.capac_cx == 0"
              :item="item"
              v-if="item.saldo > 0"
            />
          </template>

          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" class="white">
              <v-card flat class="grey lighten-3 mt-1">
                <v-card-text>
                  <v-data-table
                    :items="item.itens"
                    :headers="headers_itens"
                    no-data-text="Nenhum item encontrado"
                    hide-default-footer
                    disable-sort
                    class="tabela-itens-fc"
                    dense
                  >
                    <template v-slot:[`item.produto`]="{ item }">
                      <span
                        >{{ item.produto }} ({{ item.gp }}-{{ item.sgp }}-{{
                          item.item
                        }})</span
                      >
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn rounded text @click="dialog = false" block class="secondary"
          >Fechar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import ItensPedidoFormCarga from "./ItensPedidoFormCarga.vue";
import BtnSelecionarPedidoFormCarga from "./BtnSelecionarPedidoFormCarga.vue";
export default {
  components: { ItensPedidoFormCarga, BtnSelecionarPedidoFormCarga },
  watch: {
    dialog: async function (open) {
      if (open) {
        this.pesquisar = "";

        this.headers.find((h) => h.value == "desc_vendedor").visible =
          this.usuarioLogado.colaborador_interno;

        if (this.caixaSelec == 0) {
          this.filtroSelec = 0;
        }        
        await this.buscarPedidosLiberados();
      } else {
        this.$router.go(-1);
      }
    },
    [`cargas`]: function (value) {
      if (value.dados == null) {
        this.dialog = false;
      }
    },
  },
  computed: {
    ...mapState("formacaoCarga", [
      "cargas",
      "cargaSelec",
      "caixaSelec",
      "pedidosLiberados",
      "veiculo",
    ]),
    ...mapState("usuario", ["usuarioLogado"]),
  },
  data: () => ({
    pesquisar: "",
    headers: [
      { text: "Itens", value: "data-table-expand" },
      //{ text: "Itens", value: "itens", visible: false, sortable: false },
      { text: "Pedido", value: "nr_pedido", visible: true },
      { text: "", value: "pesquisa", visible: true },
      /*{ text: "Cód", value: "cod" },      */
      // { text: "Produto", value: "produto" },
      /*      { text: "Emb", value: "embalagem" },*/
      // { text: "Cidade", value: "cidade_entrega" },
      { text: "Representante", value: "desc_vendedor", visible: false },
      { text: "Total Pedido(Kgs)", value: "qtde_kgs", visible: true },
      //{ text: "Capac. Caixa(Kgs)", value: "capac_cx", visible: true },
      { text: "Saldo disp. p/ carregar(Kgs)", value: "saldo", visible: true },
      //{ text: "", value: "caixas", visible: true, sortable: false },
      { text: "", value: "selecionar", visible: true, sortable: false },
    ],
    headersItensCx: [
      { text: "Pedido", value: "nr_pedido", visible: true },
      //{ text: "Cód", value: "cod" },
      { text: "", value: "pesquisa", visible: true },
      { text: "Produto", value: "produto" },
      { text: "Capac. Caixa(Kgs)", value: "capac_cx", visible: true },
      { text: "Saldo disp. p/ carregar(Kgs)", value: "saldo", visible: true },
      { text: "", value: "caixas", visible: true, sortable: false },
      { text: "", value: "selecionar", visible: true, sortable: false },
    ],
    filtrosProdutos: [
      { text: "Todos", value: 0 },
      { text: "Disponíveis para esta caixa", value: 1 },
    ],
    filtroSelec: 0,
    dialog: false,
    headers_itens: [
      { text: "Produto", value: "produto" },
      { text: "Emb", value: "emb" },
      { text: "Qtde Kgs", value: "qtde_kgs" },
    ],
  }),
  methods: {
    ...mapMutations("formacaoCarga", ["setCaixa"]),
    ...mapActions("formacaoCarga", ["buscarPedidosLiberados"]),
    ...mapGetters("formacaoCarga", ["saldoProduto", "totalCarregado"]),
    formatarData(value) {
      return moment(value).format("DD/MM/yyy");
    },
    saldoDisponivel(value) {
      this.$store.state.formacaoCarga.itemSelecionado = value;
      return this.saldoProduto();
    },
    excedeuPesoMax(item) {
      return this.totalCarregado() + item.saldo > this.veiculo.dados.capac_max;
    },
    isMobile() {
      return this.$mq == "sm";
    },
    pedidosFiltrados() {
      if (this.caixaSelec > 0)
        return this.pedidosLiberados.dados.filter(
          (p) => p.capac_cx >= this.filtroSelec
        );

      return this.pedidosLiberados.dados;
    },
  },
  async created() {
    this.setCaixa(this.$route.params.cx);
    this.dialog = true;
  },
};
</script>

<style>
.v-data-table.tabela-itens-fc
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td,
.v-data-table.tabela-itens-fc
  > .v-data-table__wrapper
  > table
  > thead
  > tr
  > td,
.v-data-table.tabela-itens-fc
  > .v-data-table__wrapper
  > table
  > tfoot
  > tr
  > td {
  font-size: 0.78rem !important;
}
</style>